<script>
import api from '@/api';
import apiV2 from '@/api/v2';
import isEqual from 'lodash.isequal';
import { fetchAllItems } from '@/util/api';
import debounce from 'lodash.debounce';
import { mapPaginationToV1Format } from '@/util/query';

export default {
  name: 'FetchData',
  props: {
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    forceUpdate: {
      type: [Boolean, Number],
      default: false,
    },
    fetchAll: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: [Number, Boolean],
      default: false,
    },
    apiV2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },
  computed: {
    getDataCallback() {
      return this.debounce
        ? debounce(this.getData, this.debounce)
        : this.getData;
    },
    apiInstance() {
      return this.apiV2 ? apiV2 : api;
    },
    pagination() {
      if (this.data?.totalCount && !this.data.pagination) {
        const { perPage, page } = this.params;
        const { totalCount } = this.data;

        return mapPaginationToV1Format(perPage, page, totalCount);
      }

      return this.data.pagination;
    },
  },
  watch: {
    url: {
      handler() {
        this.fetch(this.url, this.params);
      },
      immediate: true,
    },
    forceUpdate(val) {
      if (val) this.fetch(this.url, this.params);
    },
    params: {
      handler(val, prev) {
        if (!isEqual(val, prev)) this.fetch(this.url, this.params);
      },
      deep: true,
    },
  },
  methods: {
    async fetchData(url, params) {
      if (this.fetchAll) {
        const results = await fetchAllItems(url, params, [], this.apiV2);
        return { data: { results } };
      }

      return this.apiInstance.get(url, { params });
    },
    async getData(url, params) {
      try {
        this.loading = true;
        this.$emit('data-pending', { url: this.url });
        const { data } = await this.fetchData(url, params);

        this.data = data;
        this.loading = false;
        this.$emit('data-deliver', { ...this.data, url: this.url });
      } catch {
        this.loading = false;
        throw new Error('Data error!');
      }
    },
    fetch(url, params) {
      this.loading = true;

      return this.getDataCallback(url, params);
    },
  },
  render(createElement) {
    return createElement(
      'div',
      this.$scopedSlots.default &&
        this.$scopedSlots.default({
          data: this.data,
          results: this.data.results || this.data.nodes,
          fetch: this.fetch,
          pagination: this.pagination,
          totalCount: this.data.pagination?.totalCount || this.data.totalCount,
          isLoading: this.loading,
        }),
    );
  },
};
</script>
